import React, { useState, useEffect, useRef } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { SWAL_SETTINGS } from "../../../utils/Constants";
import {
  TrimText,
  formateDate,
  formateDateWithMonth,
  prepareQuestionsFormData,
} from "../../../utils/commonfunction";
import {
  RoomDetails,
  RoomBooking,
  GetUserList,
  ReadUsersExcel,
  RoomList,
  updateBooking,
  BookingDetail, InviteesDetails,
} from "../services/room.services";
import DynamicQuestions from "../../user/shared/DynamicQuestions";
import { Button, Loader, Modal, Steps } from "rsuite";
import CustomPagination from "../../admin/common/custompagination";
import $ from "jquery";
import moment from "moment";


const SISUserBooking = () => {
  const childRef = useRef();
  const formikRef = useRef();
  const inviteMemberTrigger = useRef();
  const params = useParams();
  const [questionList, setQuestionList] = useState([]);
  const [roomDetails, setRoomDetails] = useState({});
  const navigate = useNavigate();
  const [questionFilesUploadPath] = useState("room-bookings");
  const { t } = useTranslation();
  const [userData, setUserData] = useState([]);
  let reducerData = useSelector((state) => state.manageLmBackOffice);
  const selectAllCheckbox = useRef();
  const [userdatalength, setUserDataLength] = useState(0);
  const [itemperpage] = useState(20);
  const [page, setPage] = useState(1);
  const [selectedUser, setSelectedUser] = useState([]);
  const [selectedAllDataUser, setSelectedAllDataUser] = useState(false);
  const [showSelectedUsers, setShowSelectedUsers] = useState(false);
  const [globalsearch, setGlobalSearch] = useState("");
  const [search, setSearch] = useState({});
  const [dateFilterValue, setDateFilterValue] = useState('');

  const [excelModal, setExcelModal] = useState(false);
  const [step, setStep] = React.useState(0);
  const [file, setFile] = useState("");
  const [skippedUsers, setSkippedUsers] = useState(null);
  const [selectedManualUser, setSelectedManualUser] = useState([]);
  const [selectedNewManualUser, setSelectedNewManualUser] = useState([]);
  const [selectedManualUserData, setSelectedManualUserData] = useState(false);
  const [isExcelModelOpen, setIsExcelModelOpen] = useState(false)
  const [rooms, setRooms] = useState([]);
  const [datalength, setDataLength] = useState("");
  const [calendarBookings, setCalendarBookings] = useState([]);
  const [calenderDate, setCalenderDate] = useState(moment().format("YYYY-MM-DD"));
  const [view, setView] = useState("day"); 
  const timeSlots = Array.from({ length: 24 }, (_, i) => i);
  const startOfWeek = moment(calenderDate).startOf("week");
  const weekDays = Array.from({ length: 7 }).map((_, i) =>
    startOfWeek.clone().add(i, "day")
  );
  const [dragData, setDragData] = useState(null);
  const startOfMonth = moment(calenderDate).startOf("month");
  const daysInMonth = startOfMonth.daysInMonth();
  
  useEffect(() => {
    const formData = new FormData();
    formData.append("page", params.pgno);
    formData.append("per_page", itemperpage);
    formData.append("global_search", globalsearch);
    formData.append("search", JSON.stringify(search));
    formData.append("event_id", reducerData);
    RoomList(formData)
      .then((response) => {
        if (response?.success) {
          setRooms(
            response && response.data && response.data.list
              ? response.data.list
              : []
          );
          setDataLength(response?.data?.total_records);
          setPage(
            response && response?.data && response?.data?.page
              ? response?.data?.page
              : 1
          );
          if (response?.data?.bookings_list) {
            setCalendarBookings(response.data.bookings_list);
          }
        }
        else {
          Swal.fire({
            icon: "error",
            text: response.message,
            ...SWAL_SETTINGS,
            timer: 4000
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  });

  useEffect(() => {
    RoomDetails(params?.id)
      .then((response) => {
        if (response?.success) {
          setRoomDetails(response?.data);
          setQuestionList(response?.data?.questions_data || []);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  }, []);

  useEffect(() => {
    let formData = new FormData();
    formData.append('global_search', globalsearch);
    formData.append("page", page);
    formData.append("per_page", itemperpage);
    formData.append("search", JSON.stringify(search));
    GetUserList(formData)
      .then((response) => {
        setPage(
          response && response?.data && response?.data?.page
            ? response?.data?.page
            : 1
        );
        setUserDataLength(response?.data?.total_records);
        setUserData(response?.data?.list);
        setSelectedAllDataUser(response && response.data && response.data.data_ids ? response.data.data_ids : []);
      })
      .catch((error) => {
        console.log("error", error);
      });
  }, [page, globalsearch, search]);

  const validationSchema = Yup.object().shape({
    booking_title: Yup.string().required(t('web_sis_user_booking_title_required')).trim(),
    start_date: Yup.string().required(t('web_sis_user_start_date_required')).trim(),
    end_date: Yup.string().required(t('web_sis_user_end_date_required')).trim(),
  });

  const handleClick = () => {
    inviteMemberTrigger.current.click();
  };

  const handleCloseModal = () => {
    const closeButton = document.getElementById("close_button");
    closeButton.click();
    setSelectedUser([]);
  };


  const setEndDate = (e) => {
    let room_booking_interval = roomDetails && roomDetails.bookable_interval ? roomDetails.bookable_interval : null
    if (room_booking_interval) {
      const start_date = new Date(e.target.value);
      const end_date = new Date(start_date.getTime() + room_booking_interval * 60000);
      const formattedEndDate = moment(end_date).format("YYYY-MM-DD HH:mm:ss");
      console.log(formattedEndDate, "formattedEndDate");
      formikRef?.current?.setFieldValue('end_date', formattedEndDate)
    }
  }

  /**********Handle members selection when invite members >>>>>>********* */

  useEffect(() => {
    if (selectedUser.length === userdatalength) {
      selectAllCheckbox.current.indeterminate = false;
      selectAllCheckbox.current.checked = true;
    } else if (selectedUser.length) {
      selectAllCheckbox.current.indeterminate = true;
    } else {
      selectAllCheckbox.current.indeterminate = false;
    }
  }, [selectedUser]);
  const selectUser = (userData, check) => {
    if (check) {
      setSelectedUser((previousState) => [...previousState, userData._id]);
    } else {
      setSelectedUser((previousState) =>
        previousState.filter((item) => item !== userData._id)
      );
    }
  };
  const handleSelect = (check) => {
    if (check) {
      setSelectedUser(selectedAllDataUser);
    } else {
      setSelectedUser([]);
    }
  };
  const isSelectedNew = (item) => {
    return selectedUser.filter((data) => item._id === data).length > 0;
  };

  /**********Handle members selection when invite members >>>>>>********* */

  const selectRow = (item) => {
    let id = item?._id;
    $("#" + id + "label").trigger("click");
  };

  const handleNextButtonClick = () => {
    setShowSelectedUsers(true);
    const closeButton = document.getElementById("done_button");
    closeButton.click();
  };

  // const resetFilter = (e) => {
  //   e.preventDefault();
  //   setGlobalSearch("");
  //   setSearch({});
  //   prepareSearch();
  // };

  // const prepareSearch = (key, value) => {
  //   let sr = { ...search };
  //   if (String(value).length > 0) {
  //     sr[key] = value;
  //   } else {
  //     delete sr[key];
  //   }
  //   setSearch(sr);
  // };


  const resetFilter = (e) => {
    e.preventDefault();
    setGlobalSearch("");
    setSearch({});
    setDateFilterValue("");
  };

  const prepareSearch = (key, value) => {
    let sr = { ...search };

    if (key === "createdAt" && value) {
      const start = new Date(value);
      const end = new Date(value);
      end.setHours(23, 59, 59, 999);

      sr[key] = {
        start: start.toISOString(),
        end: end.toISOString(),
      };
    } else if (String(value).length > 0) {
      sr[key] = value;
    } else {
      delete sr[key];
    }

    setSearch(sr);
  };







  const readExcelFile = (e) => {
    if (e.target.files[0]) {
      const formData = new FormData();
      formData.append("file", e.target.files[0]);
      ReadUsersExcel(formData)
        .then((response) => {
          setTimeout(() => {
            if (response?.success) {
              setFile(e?.target?.files[0]);
              setSelectedNewManualUser(response?.data?.list);
              setSelectedManualUser(response.data.list);
              setStep(step + 1);
            } else {
              Swal.fire({
                icon: "error",
                text: response.msg,
                ...SWAL_SETTINGS,
              });
              document.getElementById("file_reader").value = "";
            }
          }, 1500);
        })
        .catch((error) => {
          console.log("error", error);
          Swal.fire({
            icon: "error",
            text: error,
            ...SWAL_SETTINGS,
          });
        });
    }
  };

  const onOkayClick = () => {
    setSelectedManualUserData(JSON.stringify(selectedManualUser));
    setStep(step + 1);
  };

  const handleRemoveManualUser = (email) => {
    setSelectedManualUser(selectedManualUser.filter(user => user.email !== email));
  };

  const modalData = (steps) => {
    if (steps === 0) {
      return (
        <div className="my-3 upload-button" style={{ height: '70vh' }}>
          <form
            id="reader_id"
            style={{
              height: '300px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <div className="text-center">
              <label htmlFor="file_reader">
                <input
                  style={{ display: 'none' }}
                  type="file"
                  id="file_reader"
                  onChange={readExcelFile}
                  accept=".xls,.xlsx,.csv"
                />
                <i
                  className="fa fa-upload cp"
                  aria-hidden="true"
                  style={{ fontSize: '7em', color: '#3598ff' }}
                ></i>
              </label>
              <p className="text-muted mb-0">{t('web_sis_user_upload_excel')}</p>
              <a
                className="download-file my-0"
                href={`${process.env.REACT_APP_API_URL.replace('/webservice/api/v1', '')}/configs/default/LM-users-invitation-sample.xlsx`}
                download
              >
                {t('web_sis_user_download_sample')}
              </a>
            </div>
          </form>
        </div>
      );
    } else if (steps === 1) {
      return (
        <div className="mt-4" style={{ height: '70vh' }}>
          <div className="table-responsive">
            <table className="table card-table table-vcenter text-nowrap mb-0 border">
              <thead>
                <tr>
                  <th className="wd-lg-20p">{t('web_lbl_email')}</th>
                </tr>
              </thead>
              <tbody>
                {selectedNewManualUser.length ?
                  selectedNewManualUser.map((row, i) => (
                    <tr key={i}>
                      <td>{row.email.toLowerCase()}</td>
                    </tr>
                  )) : (
                    <tr>
                      <td colSpan={4} className="text-center">
                        {t('web_lbl_no_records')}
                      </td>
                    </tr>
                  )}

              </tbody>
            </table>
          </div>

          <div className="modal-footer mt-4 border-0">

            <button type="button" class="btn btn-secondary" onClick={() => {
              setStep(step - 1);
            }}> {t('web_event_registration_previous')}</button>
            <button type="submit" class="btn btn-primary ms-2" onClick={() => {
              onOkayClick();
              setIsExcelModelOpen(false); setStep(0);
            }}>{t('web_lbl_submit')}</button>
          </div>
        </div>
      );
    }
  };


  const goToPreviousDay = () => {
    const newDate = moment(calenderDate).subtract(1, 'day').format("YYYY-MM-DD");
    setCalenderDate(newDate);
  };

  const goToNextDay = () => {
    const newDate = moment(calenderDate).add(1, 'day').format("YYYY-MM-DD");
    setCalenderDate(newDate);
  };

  const goToToday = () => {
    setCalenderDate(moment().format("YYYY-MM-DD"));
  };

  const getBookingsForRoomAndTime = (roomId, hour) => {
    const slotStart = moment(`${calenderDate} ${hour.toString().padStart(2, '0')}:00:00`);
    const slotEnd = moment(`${calenderDate} ${hour.toString().padStart(2, '0')}:59:59`);

    return calendarBookings.filter(booking => {
      const bookingStart = moment(booking.start_date);
      const bookingEnd = moment(booking.end_date);

      return booking.room_id === roomId &&
        bookingStart.format('YYYY-MM-DD') === calenderDate &&
        bookingStart.hour() === hour;
    });
  };

  const calculateBookingHeight = (booking) => {
    const bookingStart = moment(booking.start_date);
    const bookingEnd = moment(booking.end_date);
    const durationInMinutes = bookingEnd.diff(bookingStart, 'minutes');
    const heightInPixels = (durationInMinutes / 60) * 60;
    return heightInPixels;
  };

  const calculateBookingTop = (booking, hour) => {
    const slotStart = moment(`${calenderDate} ${hour.toString().padStart(2, '0')}:00:00`);
    const bookingStart = moment(booking.start_date);
    const minutesFromStart = bookingStart.diff(slotStart, 'minutes');
    return minutesFromStart;
  };
  
  const handleDragStart = (e, booking, room) => {
    setDragData({ booking, room });
  };

  const handleDrop = (e, newRoom, newHour,dropDay = null) => {
    if (!dragData) return;

      const { booking } = dragData;

      const duration = moment(booking.end_date)
        .diff(moment(booking.start_date), "minutes");
        
      const baseDate = dropDay ? moment(dropDay) : moment(calenderDate);

      const newStart = baseDate
        .clone()
        .hour(newHour)
        .minute(0);

      const newEnd = newStart.clone().add(duration, "minutes");
    
      const payload = {
        _id: booking._id,
        event_id: newRoom.event_id?._id ?? newRoom.event_id,
        room_id: newRoom._id,
        title: booking.title,
        start_date: newStart.toISOString(),
        end_date: newEnd.toISOString(),
      };
      
    // API call here
    updateBooking(payload)
      .then((response) => {
        if (response?.success) {
          Swal.fire({
            icon: "success",
            text: response?.message,
            ...SWAL_SETTINGS,
          });
        }else {
          Swal.fire({
            icon: "error",
            text: response?.message,
            ...SWAL_SETTINGS,
          });
        }
        
      });

    setDragData(null);
  };
  const handleBookingClick = async (booking, room) => {
    let bookingDetail = await getBookingDetail(booking?._id);
    let inviteesData = await getInviteesDetails(bookingDetail?.invitees);

    const inviteesHtml = inviteesData?.length
      ? inviteesData.map(invitee => `
          <div style="margin-bottom:8px;">
            <div style="font-weight:500;">${invitee.name || '-'}</div>
            <div style="font-size:15px; color:#666;">${invitee.email || ''}</div>
          </div>
        `).join('')
      : '<div style="color:#888;">No invitees</div>';

    Swal.fire({
      title: '<h2 style="font-weight:500; margin-bottom:15px;">Booking Details</h2>',
      html: `
        <div style="
          text-align:left;
          background:#f9f9f9;
          padding:15px 20px;
          border-radius:12px;
          box-shadow:0 2px 6px rgba(0,0,0,0.1);
          font-size:15px;
          line-height:1.6;
        ">
          <p><strong>Title:</strong> ${booking.title || '-'}</p>
          <p><strong>Room:</strong> ${room?.name || '-'}</p>
          <p><strong>Start:</strong> ${moment(booking.start_date).format('DD/MM/YYYY h:mm A')}</p>
          <p><strong>End:</strong> ${moment(booking.end_date).format('DD/MM/YYYY h:mm A')}</p>

          <p style="margin-top:10px;"><strong>Invitees:</strong></p>
          <div style="padding-left:4px;">
            ${inviteesHtml}
          </div>
        </div>
      `,
      showConfirmButton: false,
      showCloseButton: true,
      width: 380,
      customClass: {
        popup: 'swal2-card-view'
      },
    });
  };
  const getBookingDetail = async(bookingId) => {
    try{
      const response = await BookingDetail(bookingId);      
      if(response.success){                
        return response.data;
      }
      return null;
    }catch(err){
        console.log(err);
        return null
    };
  };
  const getInviteesDetails = async (invitees) =>  {
    try {
      const formData = new FormData();
      formData.append('invitees', JSON.stringify(invitees));
      const response = await InviteesDetails(formData)
      return response && response.data ? response.data : [];
    } catch (error) {
      console.log("error=====>", error);
    }
  };
  const getRoomDetails = async(roomId) => {
    try{
      const response = await RoomDetails(roomId);
      if(response.success){
        return response.data;
      }
      return null;
    }catch(err){
        console.log(err);
        return null
    };
  };
  const renderBookingBlock = (booking, room = null) => {
      return (
        <div
          key={booking._id}
          draggable
          onDragStart={(e) => handleDragStart(e, booking, room)}
          onClick={() => handleBookingClick(booking, room)}
          style={{
            background: '#3788d8',
            color: 'white',
            padding: '4px',
            borderRadius: '4px',
            cursor: 'move',
            fontSize: '12px',
            marginBottom: '2px'
          }}
        >
          <div style={{ fontWeight: 'bold' }}>
            {booking.title || 'Booking'}
          </div>
          <div style={{ fontSize: '11px' }}>
            {moment(booking.start_date).format('HH:mm')} - {moment(booking.end_date).format('HH:mm')}
          </div>
        </div>
      );
    };
  

  return (
    <>
      <Formik
        innerRef={formikRef}
        enableReinitialize
        initialValues={{
          start_date: "",
          end_date: "",
          booking_title: "",
        }}
        validationSchema={validationSchema}
        onSubmit={(values, { setSubmitting }) => {
          let formResult = childRef?.current?.submit();
          if (formResult && formResult?.isValid) {
            const formData = new FormData();

            let startDate = new Date(values?.start_date);
            let isoStartDate = startDate.toISOString();

            let endDate = new Date(values?.end_date);
            let isoEndDate = endDate.toISOString();

            formData.append("event_id", reducerData);
            formData.append("start_date", isoStartDate);
            formData.append("end_date", isoEndDate);
            formData.append("title", values?.booking_title);
            formData.append("room_id", params.id);
            if (selectedUser && selectedUser.length > 0 && selectedUser != null) {
              formData.append("invitees", JSON.stringify(selectedUser));
            }

            if (selectedManualUser && selectedManualUser.length > 0) {
              let emails = selectedManualUser.map(user => user.email)
              formData.append("manualInvitees", JSON.stringify(emails));
            }
            let result = childRef?.current?.getValues();
            let finalForm = prepareQuestionsFormData(
              result,
              formData,
              questionFilesUploadPath
            );
            RoomBooking(finalForm)
              .then((response) => {
                if (response?.success) {
                  Swal.fire({
                    icon: "success",
                    text: response?.message,
                    ...SWAL_SETTINGS,
                  });
                  navigate("/sis-user/rooms/list/1");
                } else {
                  Swal.fire({
                    icon: "error",
                    text: response?.message,
                    ...SWAL_SETTINGS,
                  });
                }
              })
              .catch((error) => {
                console.log("error", error);
              });
          } else {
            Swal.fire({
              icon: "error",
              text: (t('web_sis_user_all_required_information')),
              ...SWAL_SETTINGS,
            });
          }
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          setFieldTouched,
          isSubmitting,
        }) => (
          <div className="wraper-inner cpt bg-grey">
            <section className="inner-space pt-0">
              <div className="w-100 px-3">
                <form
                  onSubmit={async (e) => {
                    handleSubmit(e);
                  }}
                >
                  
                  <div className="row">
                    <div className="col-md-9 m-auto ">
                      <h3 className="inner-title mb-0 mt-5">{t('web_lbl_room_booking')}</h3>
                      <div style={{display: "flex"}}>
                        <div className="dash-box-shadow space-b" style={{ maxWidth: "37%",marginRight: "10px" }}>
                          <div className="row add-coustomer">
                            <div className="col-12">
                              <div
                                className="w-100 p-4 mb-4 rounded-2"
                                style={{
                                  backgroundColor: "var(--light_active_color)",
                                }}
                              >
                                <h3 className="text-capitalize mb-2">
                                  {roomDetails?.name
                                    ? TrimText(roomDetails?.name)
                                    : null}
                                </h3>
                                <div className="date-info pb-0">
                                  <i className="ri-calendar-event-line"></i>
                                  {formateDateWithMonth(roomDetails?.start_date) +
                                    " - " +
                                    formateDateWithMonth(roomDetails?.end_date)}
                                </div>
                              </div>
                            </div>
                            <div className="form-group  mb-4 col-md-6">
                              <label className="form-label">
                                {t('web_sis_user_booking_title')}<small>*</small>
                              </label>
                              <div>
                                <input
                                  name="booking_title"
                                  id="booking_title"
                                  type="text"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.booking_title}
                                  className="form-control"
                                />
                              </div>
                              <span className="text-danger d-flex text-left">
                                {errors.booking_title &&
                                  touched.booking_title &&
                                  errors.booking_title}
                              </span>
                            </div>
                            <div className="form-group  mb-4 col-md-6">
                              <label className="form-label">{t('web_sis_user_start_date')}</label>
                              <div>
                                <input
                                  name="start_date"
                                  id="start_date"
                                  type="datetime-local"
                                  onChange={(e) => { handleChange(e); setEndDate(e) }}
                                  onBlur={handleBlur}
                                  onClick={(e) => e.target.showPicker()}
                                  value={values.start_date}
                                  className="form-control"
                                />
                              </div>
                              <span className="text-danger d-flex text-left">
                                {errors.start_date &&
                                  touched.start_date &&
                                  errors.start_date}
                              </span>
                            </div>
                            {/* <div className="form-group  mb-4 col-md-6">
                              <label className="form-label">
                                End Date<small>*</small>
                              </label>
                              <div>
                                <input
                                  name="end_date"
                                  id="end_date"
                                  type="datetime-local"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  onClick={(e) => e.target.showPicker()}
                                  value={values.end_date}
                                  className="form-control"
                                />
                                <span className="text-danger d-flex text-left">
                                  {errors.end_date &&
                                    touched.end_date &&
                                    errors.end_date}
                                </span>
                              </div>
                            </div> */}
                            <div className="form-group  mb-4 col-md-6">
                              <label className="form-label">
                                <span></span>
                              </label>
                              <div>
                                <button
                                  className="btn btn-primary"
                                  type="button"
                                  onClick={() => handleClick()}
                                >
                                  {t('web_sis_user_invite_member')}
                                </button>
                                {showSelectedUsers && selectedUser?.length > 0 && (
                                  <span className="ml-auto ms-2">
                                    {t('web_sis_user_total_selected_user')}: {selectedUser?.length}
                                  </span>
                                )}
                                {selectedManualUser && selectedManualUser?.length > 0 && (
                                  <span className="ml-auto ms-2">
                                    {t('web_sis_user_total_selected_manual_member')}: <span>({selectedManualUser?.length})</span>
                                  </span>
                                )}
                              </div>
                            </div>
                            {selectedManualUser && selectedManualUser.length > 0 && (
                              <>
                                <h4>{t('web_sis_user_manual_users')}</h4>
                                <div className="manual-invitees-chips mt-2 mb-2">
                                  {selectedManualUser.map((user, index) => (
                                    <div key={index} className="chip">
                                      {user.email}
                                      <button className="close-btn" type="button" onClick={() => handleRemoveManualUser(user.email)}>
                                        &times;
                                      </button>
                                    </div>
                                  ))}
                                </div>
                              </>
                            )}
                            {questionList.length > 0 ? (
                              <h4 className="mb-3 mt-3">
                                {t("web_lbl_more_info")}
                              </h4>
                            ) : null}
                            <div className="form-group mb-4 col-md-12">
                              {/* {questionList.length > 0 ? ( */}
                              <div>
                                <DynamicQuestions
                                  ref={childRef}
                                  questions={questionList}
                                  showCount={false}
                                  questionTitleClass=""
                                  footer=""
                                  videoUploadPath={questionFilesUploadPath}
                                />
                              </div>
                              {/* ) : null} */}
                            </div>
                            <div className="btn-group mt-4 col-md-12">
                              <button
                                className="btn btn-primary"
                                type="submit"
                                onClick={() => {
                                  childRef?.current?.submit();
                                }}
                              >
                                {t('web_event_registration_continue')}
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="dash-box-shadow space-b" style={rooms.length === 0 ? { width: "100%" } : { maxWidth: "63%" }}>
                          <div className="container-fluid">
                            {rooms.length === 0 ? (
                              <div className="text-center py-5">
                                <h4>No Rooms Available</h4>
                                <p className="text-muted">Please add rooms to view calendar</p>
                              </div>
                            ) : (
                              
                              <div>
                                {/* Calendar Header */}
                                <div className="d-flex justify-content-between align-items-center p-3 border-bottom">
                                  <h4 className="mb-0">{moment(calenderDate).format('MMMM D, YYYY')}</h4>
                                  <div className="d-flex gap-2 align-items-center">
                                    <input
                                      type="date"
                                      className="form-control"
                                      style={{ minWidth: '70px',height: '30px', fontSize : '15px' }}
                                      value={calenderDate}
                                      onChange={(e) => setCalenderDate(e.target.value)}
                                    />
                                    <button className="btn btn-secondary" style={{ minWidth: '60px',height: '30px' }} onClick={goToToday}>
                                      Today
                                    </button>
                                    <button className="btn btn-primary" style={{ minWidth: '60px',height: '30px' }} onClick={goToPreviousDay}>
                                      &lt;
                                    </button>
                                    <button className="btn btn-primary" style={{ minWidth: '60px',height: '30px' }} onClick={goToNextDay}>
                                      &gt;
                                    </button>
                                  </div>
                                    <div className="btn-group ms-2">
                                      <button
                                        className={` ${view === "day" ? "btn btn-secondary" : "btn btn-primary"}`}
                                        style={{ minWidth: '60px',height: '30px' }}
                                        onClick={() => setView("day")}
                                      >
                                        Day
                                      </button>
                                      <button
                                        className={` ${view === "week" ? "btn btn-secondary" : "btn btn-primary"}`}
                                        style={{ minWidth: '60px',height: '30px' }}
                                        onClick={() => setView("week")}
                                      >
                                        Week
                                      </button>
                                      <button
                                        className={` ${view === "month" ? "btn btn-secondary" : "btn btn-primary"}`}
                                        style={{ minWidth: '60px',height: '30px' }}
                                        onClick={() => setView("month")}
                                      >
                                        Month
                                      </button>
                                    </div>
                                </div>
            
                                {/* Calendar Grid */}
                                {view === "day" && (
                                  <div style={{ overflowX: 'auto', overflowY: 'auto', maxHeight: '70vh' }}>
                                    <table className="table table-bordered" style={{ minWidth: '800px' }}>
                                      <thead style={{ position: 'sticky', top: 0, background: 'white', zIndex: 10 }}>
                                        <tr>
                                          <th style={{ width: '80px', minWidth: '80px' }}>Time</th>
                                          {rooms.map((room) => (
                                            <th key={room._id} style={{ minWidth: '200px', textAlign: 'center' }}>
                                              {room.name}
                                            </th>
                                          ))}
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {timeSlots.map((hour) => (
                                          <tr key={hour} style={{ height: '60px' }}>
                                            <td style={{
                                              verticalAlign: 'top',
                                              padding: '4px 8px',
                                              fontWeight: '500',
                                              background: '#f8f9fa'
                                            }}>
                                              {hour.toString().padStart(2, '0')}:00
                                            </td>
                                            {rooms.map((room) => {
                                              const bookings = getBookingsForRoomAndTime(room._id, hour);
                                              return (
                                                <td
                                                  key={`${room._id}-${hour}`}
                                                  onDragOver={(e) => e.preventDefault()}
                                                  onDrop={(e) => handleDrop(e, room, hour)}
                                                  // onClick={() => handleEmptySlotClick(room, hour)}
                                                  style={{
                                                    position: 'relative',
                                                    padding: 0,
                                                    verticalAlign: 'top',
                                                    background: hour % 2 === 0 ? '#fafafa' : 'white'
                                                  }}
                                                >
                                                  {bookings.map((booking, idx) => {
                                                    const bookingStart = moment(booking.start_date);
                                                    const slotStart = moment(`${calenderDate} ${hour.toString().padStart(2, '0')}:00:00`);
            
                                                    // Only render if this is the starting slot
                                                    if (bookingStart.hour() !== hour) {
                                                      return null;
                                                    }
            
                                                    const height = calculateBookingHeight(booking, hour);
                                                    const top = calculateBookingTop(booking, hour);
            
                                                    return (
                                                      <div
                                                        key={idx}
                                                          draggable
                                                          onDragStart={(e) =>
                                                            handleDragStart(e, booking, room)
                                                          }
                                                          onClick={() => handleBookingClick(booking, room)}
                                                          style={{
                                                            top: `${top}%`,
                                                            left: '2px',
                                                            right: '2px',
                                                            height: `${height}%`,
                                                            background: '#3788d8',
                                                            color: 'white',
                                                            padding: '4px',
                                                            borderRadius: '4px',
                                                            cursor: 'move',
                                                            overflow: 'hidden',
                                                            fontSize: '12px',
                                                            zIndex: 1
                                                          }}
                                                      >
                                                        <div style={{ fontWeight: 'bold' }}>
                                                          {booking.title || 'Booking'}
                                                        </div>
                                                        <div style={{ fontSize: '11px' }}>
                                                          {moment(booking.start_date).format('HH:mm')} - {moment(booking.end_date).format('HH:mm')}
                                                        </div>
                                                      </div>
                                                    );
                                                  })}
                                                </td>
                                              );
                                            })}
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                  </div>
                                )}
                                {view === "week" && (
                                  <div style={{ overflowX: "auto", maxHeight: "70vh" }}>
                                    <table className="table table-bordered">
                                      <thead>
                                        <tr>
                                          <th style={{ width: "80px" }}>Time</th>
                                          {weekDays.map((day) => (
                                            <th key={day.format()} className="text-center">
                                              {day.format("ddd DD")}
                                            </th>
                                          ))}
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {timeSlots.map((hour) => (
                                          <tr key={hour}>
                                            <td>{hour.toString().padStart(2, "0")}:00</td>
            
                                            {weekDays.map((day) => (
                                              <td
                                                key={day.format() + hour}
                                                style={{ height: "60px", position: "relative" }}
                                                onDragOver={(e) => e.preventDefault()}
                                                onDrop={async(e) => {
                                                  if (!dragData) return;
            
                                                  const { booking } = dragData;
                                                  const roomDetails = await getRoomDetails(booking.room_id);
                                                  
                                                  handleDrop(e, roomDetails, hour,day);
            
                                                  setDragData(null);
                                                }}
            
                                              >
                                                {calendarBookings
                                                  .filter((booking) =>
                                                    moment(booking.start_date).format("YYYY-MM-DD") ===
                                                      day.format("YYYY-MM-DD") &&
                                                    moment(booking.start_date).hour() === hour
                                                  )
                                                  .map((booking) =>
                                                    renderBookingBlock(booking)
                                                  )}
                                              </td>
                                            ))}
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                  </div>
                                )}
            
                                {view === "month" && (
                                  <div className="p-3">
                                    <div className="row">
                                      {Array.from({ length: daysInMonth }).map((_, i) => {
                                        const day = startOfMonth.clone().add(i, "day");
            
                                        return (
                                          <div
                                            key={i}
                                            className="col-2 border p-2"
                                            style={{ minHeight: "120px" }}
                                            onDragOver={(e) => e.preventDefault()}
                                            onDrop={async(e) => {
                                              if (!dragData) return;
            
                                              const { booking } = dragData;
            
                                              const roomDetails = await getRoomDetails(booking.room_id);
                                              
                                              handleDrop(e, roomDetails, 9,day);
            
                                              setDragData(null);
                                            }}
            
                                          >
                                            <div style={{ fontWeight: "bold" }}>
                                              {day.format("DD")}
                                            </div>
            
                                            {calendarBookings
                                              .filter(
                                                (booking) =>
                                                  moment(booking.start_date).format("YYYY-MM-DD") ===
                                                  day.format("YYYY-MM-DD")
                                              )
                                              .map((booking) =>
                                                renderBookingBlock(booking)
                                              )}
                                          </div>
                                        );
                                      })}
                                    </div>
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </section>
          </div>
        )}
      </Formik>
      <a
        className="d-none"
        ref={inviteMemberTrigger}
        data-bs-toggle="modal"
        href="#ChoosePayment"
        role="button"
      >
        <span></span>
      </a>
      <div
        className="modal fade"
        id="ChoosePayment"
        aria-hidden="true"
        data-bs-backdrop="static"
        aria-labelledby="ChoosePaymentLabel"
        tabIndex={-1}
        style={{ zIndex: 10000 }}
      >

        {isExcelModelOpen == false ?
          <>
            <div className="modal-dialog modal-fullscreen">
              <div className="modal-content">

                <div className="modal-header">
                  <div className="user-right filter-responsive d-flex align-items-center">
                    <div className="select-check-container">
                      <label htmlFor="selectAllCheck" style={{ lineHeight: 'unset' }} className="ckbox cp">
                        <input ref={selectAllCheckbox} id="selectAllCheck" checked={userdatalength && userdatalength === selectedUser.length}
                          onChange={(e) => handleSelect(e.target.checked)} type="checkbox" />
                        <span className="ms-1 no-select no-before">{t('web_sis_user_select_all')}</span>
                      </label>
                    </div>
                    <div className="search-box ms-2">
                      <input
                        type="text"
                        name=""
                        className="form-control rounded-3"
                        placeholder={t('web_lbl_search')}
                        value={globalsearch}
                        onChange={(e) => {
                          setGlobalSearch(e.target.value);
                        }}
                      />
                      <button className="btn-search">
                        <i className="ti ti-search"></i>
                      </button>
                    </div>
                    <div className="form-group ms-2">
                      <input
                        className="form-control"
                        type="date"
                        value={dateFilterValue}
                        onChange={(e) => {
                          setDateFilterValue(e.target.value);
                          prepareSearch("createdAt", e.target.value);
                        }}
                        onClick={(e) => {
                          e.target.showPicker();
                        }}
                        placeholder={t('web_lbl_filter_by_date')}
                      ></input>
                    </div>
                    <button
                      className="btn btn-warning ms-1"
                      onClick={(e) => {
                        resetFilter(e);
                      }}
                    >
                      {t("web_lbl_reset_filter")}
                    </button>
                    <button
                      type="button"
                      value="upload_excel"
                      className="btn btn-success float-right ms-2"
                      onClick={() => {
                        setIsExcelModelOpen(true);
                      }}
                    >
                      {t('web_sis_user_invite_manually')}
                    </button>
                  </div>
                  <button
                    type="button"
                    className="btn-close"
                    id="close_button"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={() => {
                      handleCloseModal();
                    }}
                  ></button>
                  <button
                    type="button"
                    className="btn-close d-none"
                    id="done_button"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body" >
                  <div className="row">
                    {userData.length ? (
                      userData.map((item, i) => {
                        return (
                          <div key={i} onClick={() => selectRow(item)} className={"col-xl-3 col-lg-4 col-md-6"} >
                            <div className="check_container w-100">
                              <div className="w-100 h-100 p-2">
                                <strong>{item?.name ? TrimText(item.name, 30) : "N/A"}</strong>
                                <span className="d-block text-muted">{item?.email ? item.email : "N/A"}</span>
                                <span className="d-block text-muted">{item.createdAt ? formateDate(item.createdAt) : "N/A"}</span>
                              </div>
                              <input type="checkbox" onChange={(e) => selectUser(item, e?.target?.checked)} id={"select-checkbox" + i} checked={isSelectedNew(item)} />
                              <label htmlFor={"select-checkbox" + i}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-check-circle-fill" viewBox="0 0 16 16" >
                                  <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                                </svg>
                              </label>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div colSpan={6} className="text-center">
                        {t('web_lbl_no_records')}
                      </div>
                    )}
                  </div>
                  <div className="d-flex justify-content-between align-items-center mt-3">
                    <div id="example1_info" role="status" aria-live="polite" >
                      <b>{t('web_sis_user_total_records')} : {userdatalength ? userdatalength : "0"}</b>
                    </div>
                    {userdatalength && userdatalength > 0 ? (
                      <CustomPagination
                        datalength={userdatalength}
                        itemperpage={itemperpage}
                        currentPage={page}
                        setPage={setPage}
                        modalPagination={"modalPagination"}
                      />
                    ) : (
                      ""
                    )}
                  </div>

                </div>
                <div className="modal-footer">
                  <div className="d-flex justify-content-between align-items-center w-100">
                    <h4> {selectedUser.length ? "Selected " + selectedUser.length + " of records " + userdatalength : ""} </h4>
                    <button
                      type="button"
                      className="btn btn-primary"
                      disabled={selectedUser.length === 0}
                      onClick={handleNextButtonClick}
                    >
                      {t('web_registration_next')}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </>
          :
          <div className="modal-dialog modal-fullscreen">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title" id="exampleModalLongTitle">{t('web_sis_user_invite_manually')}</h4>

                <button
                  type="button"
                  className="btn-close"
                  id="close_button_excel"
                  aria-label="Close"
                  onClick={() => { setIsExcelModelOpen(false); setStep(0) }}
                ></button>
              </div>
              <div class="modal-body">
                {modalData(step)}
              </div>
            </div>
          </div>
        }
      </div>
      <button
        type="button"
        className="btn btn-primary"
        data-toggle="modal"
        data-target="#exampleModalCenter"
        id="modal-invite"
        style={{ display: 'none' }}
      >
        Launch demo modal
      </button>


    </>
  );
};
export default SISUserBooking;
